exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".project.complete{border-left:4px solid green}.project.ongoing{border-left:4px solid orange}.project.overdue{border-left:4px solid red}.scrollbar1{width:100%;height:700px;background-color:#fff;overflow-y:auto;overflow-x:hidden;scrollbar-color:#639 green;scrollbar-width:auto}#wrapper{text-align:center;width:500px;margin:auto}#style-11::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.3);border-radius:10px;background-color:#f5f5f5}#style-11::-webkit-scrollbar{width:12px;background-color:#f5f5f5}#style-11::-webkit-scrollbar-thumb{border-radius:10px;-webkit-box-shadow:inset 0 0 8px rgba(0,0,0,.3)}", ""]);

// exports
